
































import {
  defineComponent,
  useContext,
  useMeta,
  useRoute,
  computed,
  watch,
} from '@nuxtjs/composition-api'
import { useBreadcrumb } from '~/composables/ui/useBreadcrumb'
import { useContent } from '~/composables/useContent'
import { useLocale } from '~/composables/useLocale'
import { useBreadcrumbsSchemaScript } from '~/composables/useSchemaScript'

export default defineComponent({
  name: 'PagesBlogTag',

  setup() {
    const { article } = useContent()
    const { i18n, localePath } = useContext()

    const { breadcrumbs, setBreadcrumbs } = useBreadcrumb()
    const {
      breadcrumbsSchemaScript,
      setBreadcrumbsSchemaScript,
    } = useBreadcrumbsSchemaScript()

    const pageTitle = computed(
      () => article.value?.title || route.value?.params?.pathMatch
    )

    const { currentCode, changeLocaleLinks, clearLocaleLinks } = useLocale()
    const route = useRoute()

    const doChangeLocaleLinks = () => {
      if (!article.value) return

      if (article.value.urlLocales) {
        const localeLinks: Record<string, string> = {}
        localeLinks[currentCode.value] = route.value.fullPath

        for (const locale in article.value.urlLocales) {
          localeLinks[locale] = localePath(
            {
              name: 'blog-tag-all',
              params: { pathMatch: article.value.urlLocales[locale] },
            },
            locale
          )
        }

        changeLocaleLinks(localeLinks)
      } else {
        clearLocaleLinks()
      }
    }

    if (process.client) {
      watch(
        article,
        (article) => {
          if (article) {
            doChangeLocaleLinks()

            setBreadcrumbs([
              {
                label: i18n.t('title.news') as string,
                to: {
                  name: 'blog-category',
                },
              },
              {
                label: pageTitle.value as string,
              },
            ])
            setBreadcrumbsSchemaScript(breadcrumbs.value!)
          }
        },
        {
          immediate: true,
        }
      )
    }

    useMeta(() => {
      return breadcrumbsSchemaScript.value
        ? {
            script: [breadcrumbsSchemaScript.value],
          }
        : {}
    })

    return {
      article,
      pageTitle,
    }
  },

  head: {},
})
